import { useQuery } from '@tanstack/react-query';
import { useCustomersSyncApi } from './use-customers-sync-api';
import { useCustomersSyncSettings } from './use-customers-sync-settings';

const QK_CUSTOMER_LOOKUP = (identifier: string) =>
  ['customers-sync', 'lookup', identifier] as const;

export function useCustomerLookupQuery(identifier: string | undefined) {
  const { customersSyncApi } = useCustomersSyncApi();
  const settings = useCustomersSyncSettings();

  return useQuery({
    queryKey: QK_CUSTOMER_LOOKUP(identifier ?? ''),
    queryFn: () => customersSyncApi.lookup(identifier ?? '', settings),
    enabled: !!identifier,
    retry: false,
  });
}
